import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Configuration } from '@app/common/configuration';
import { UserLoginInfo } from '@app/apiModules/userLoginInfo';
import { apiResponseFormat } from '@app/common/variables';
import { TokenResponseDto } from './TokenResponseDto';

@Injectable({
    providedIn: 'root'
})
export class TokenManagementService {
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    authServerUrl = environment.API_APP_PATH;

    constructor(private readonly http: HttpClient) {

    }
    public getTokens(
        username: string,
        observe?: "body",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<TokenResponseDto>;
    public getTokens(
        username: string,
        observe?: "response",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<HttpResponse<TokenResponseDto>>;
    public getTokens(
        username: string,
        observe?: "events",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<HttpEvent<TokenResponseDto>>;
    public getTokens(
        username: string,
        observe: any = "body",
        reportProgress = false,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<any> {
        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined =
            options?.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            const httpHeaderAccepts: string[] = [
                "text/plain",
                "application/json",
                "text/json",
            ];
            httpHeaderAcceptSelected =
                this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        let responseType: "text" | "json" = "json";
        if (
            httpHeaderAcceptSelected?.startsWith("text")
        ) {
            responseType = "text";
        }

        return this.http.get<any>(
            `${this.authServerUrl}/api/app/token-management/token-sso?username=${encodeURIComponent(username)}`,
            {
                responseType: responseType as any,
                withCredentials: true,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            }
        );
    }
    public refreshToken(
        refresh_token: string,
        observe?: "body",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<any>;
    public refreshToken(
        refresh_token: string,
        observe?: "response",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<HttpResponse<any>>;
    public refreshToken(
        refresh_token: string,
        observe?: "events",
        reportProgress?: boolean,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<HttpEvent<any>>;
    public refreshToken(
        refresh_token: string,
        observe: any = "body",
        reportProgress = false,
        options?: {
            httpHeaderAccept?: apiResponseFormat;
        }
    ): Observable<any> {
        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined =
            options?.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            const httpHeaderAccepts: string[] = [
                "text/plain",
                "application/json",
                "text/json",
            ];
            httpHeaderAcceptSelected =
                this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        let responseType: "text" | "json" = "json";
        if (
            httpHeaderAcceptSelected?.startsWith("text")
        ) {
            responseType = "text";
        }
        const formData = new FormData();
        formData.append("refresh_token", refresh_token);
        return this.http.post<any>(
            `${this.authServerUrl}/api/app/token-management/refresh-token`,
            formData,
            {
                responseType: responseType as any,
                withCredentials: false,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            }
        );
    }
   
}
